import { bookmarkRoutes, catalogExtraRoutes } from "./bookmarks";
import { botAdminRoutes, botRoutes } from "./bot";
import { internalRoutes } from "./internal";
import {
  adminRoutes,
  authRoutes,
  catalogRoutes,
  downloadsRoutes,
  personalRoutes,
  policyRoutes,
  readerRoutes,
  usersRoutes,
} from "./public";
import type { ApiModule, RouteSpec } from "./route";
import { videoInternalRoutes, videoRoutes } from "./videos";

/** Every route of the system, keyed by id (`<module>.<name>`). Frozen after T0: add routes only via the coordinator. */
export const ROUTES = {
  ...authRoutes,
  ...botRoutes,
  ...botAdminRoutes,
  ...usersRoutes,
  ...personalRoutes,
  ...bookmarkRoutes,
  ...catalogExtraRoutes,
  ...catalogRoutes,
  ...policyRoutes,
  ...adminRoutes,
  ...downloadsRoutes,
  ...readerRoutes,
  ...internalRoutes,
  ...videoRoutes,
  ...videoInternalRoutes,
} as const;

export type RouteId = keyof typeof ROUTES;
export type RouteById<K extends RouteId> = (typeof ROUTES)[K];

export const ROUTE_LIST: readonly (RouteSpec & { id: RouteId })[] = Object.values(ROUTES);

export function routesOfModule<M extends ApiModule>(module: M): (RouteSpec & { id: RouteId })[] {
  return ROUTE_LIST.filter((r) => r.module === module);
}
